// extracted by mini-css-extract-plugin
export default {"container":"Mono_container__7u83B","main":"Mono_main__CuHH+","body":"Mono_body__sUBh3"};